import { useState, useCallback, useEffect } from "react";
import * as serviceWorkerRegistration from "../../serviceWorkerRegistration";

const useServiceWorker = () => {
  const [waitingWorker, setWaitingWorker] = useState(null);
  const [showReload, setShowReload] = useState(false);

  const onSWUpdate = useCallback((registration) => {
    setShowReload(true);
    setWaitingWorker(registration.waiting);
  }, []);

  const reloadPage = useCallback(() => {
    setShowReload(false);

    if (!waitingWorker) {
      window.location.reload();
      return;
    }

    let reloaded = false;
    const doReload = () => {
      if (reloaded) return;
      reloaded = true;
      window.location.reload();
    };

    navigator.serviceWorker?.addEventListener("controllerchange", doReload, {
      once: true,
    });

    setTimeout(doReload, 3000);

    waitingWorker.postMessage({ type: "SKIP_WAITING" });
  }, [waitingWorker]);

  useEffect(() => {
    serviceWorkerRegistration.register({
      onUpdate: onSWUpdate,
    });
  }, [onSWUpdate]);

  return { showReload, waitingWorker, reloadPage };
};

export default useServiceWorker;
